import React from 'react';

export const Doc = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width ?? '44'}
    height={height ?? '45'}
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_523_7864)">
      <path
        d="M8.8 29.8334V21.0334H10.2667C10.6557 21.0334 11.0287 21.188 11.3038 21.463C11.5788 21.7381 11.7333 22.1111 11.7333 22.5001V28.3668C11.7333 28.7558 11.5788 29.1288 11.3038 29.4039C11.0287 29.6789 10.6557 29.8334 10.2667 29.8334H8.8ZM20.5333 22.5001C20.5333 22.1111 20.6879 21.7381 20.9629 21.463C21.238 21.188 21.611 21.0334 22 21.0334C22.389 21.0334 22.762 21.188 23.0371 21.463C23.3121 21.7381 23.4667 22.1111 23.4667 22.5001V28.3668C23.4667 28.7558 23.3121 29.1288 23.0371 29.4039C22.762 29.6789 22.389 29.8334 22 29.8334C21.611 29.8334 21.238 29.6789 20.9629 29.4039C20.6879 29.1288 20.5333 28.7558 20.5333 28.3668V22.5001Z"
        fill={color || '#4969DA'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.93333 4.9C2.93333 3.73305 3.3969 2.61389 4.22206 1.78873C5.04722 0.96357 6.16638 0.5 7.33333 0.5L31.4072 0.5L41.0667 10.1595V40.1C41.0667 41.267 40.6031 42.3861 39.7779 43.2113C38.9528 44.0364 37.8336 44.5 36.6667 44.5H7.33333C6.16638 44.5 5.04722 44.0364 4.22206 43.2113C3.3969 42.3861 2.93333 41.267 2.93333 40.1V4.9ZM10.2667 18.1H5.86667V32.7667H10.2667C11.4336 32.7667 12.5528 32.3031 13.3779 31.4779C14.2031 30.6528 14.6667 29.5336 14.6667 28.3667V22.5C14.6667 21.333 14.2031 20.2139 13.3779 19.3887C12.5528 18.5636 11.4336 18.1 10.2667 18.1ZM22 18.1C20.833 18.1 19.7139 18.5636 18.8887 19.3887C18.0636 20.2139 17.6 21.333 17.6 22.5V28.3667C17.6 29.5336 18.0636 30.6528 18.8887 31.4779C19.7139 32.3031 20.833 32.7667 22 32.7667C23.167 32.7667 24.2861 32.3031 25.1113 31.4779C25.9364 30.6528 26.4 29.5336 26.4 28.3667V22.5C26.4 21.333 25.9364 20.2139 25.1113 19.3887C24.2861 18.5636 23.167 18.1 22 18.1ZM29.3333 32.7667V18.1H38.1333V23.9667H35.2V21.0333H32.2667V29.8333H35.2V26.9H38.1333V32.7667H29.3333Z"
        fill={color || '#4969DA'}
      />
    </g>
    <defs>
      <clipPath id="clip0_523_7864">
        <rect
          width="44"
          height="44"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
